import React from 'react';

interface PortalHeadingProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Right of the title on desktop, under it on phones (e.g. the code entry). */
  aside?: React.ReactNode;
}

/** A portal page title: Plus Jakarta 28px (24px on phones) over a muted line. */
export function PortalHeading({ title, description, aside }: PortalHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between md:gap-8">
      <div className="flex min-w-0 flex-col gap-1 md:gap-1.5">
        <h1 className="font-display text-2xl font-bold leading-[1.2] tracking-[-0.02em] text-foreground md:text-[28px] md:leading-[1.15]">
          {title}
        </h1>
        {description && <p className="text-[15px] text-muted-foreground">{description}</p>}
      </div>
      {aside}
    </div>
  );
}

export default PortalHeading;
